// src/components/HomeSlider.js
import React from 'react';
import './HomeSlider.css';

const HomeSlider = () => {
  return (
    <div className="home-slider" id="home">
      <video
        className="home-video"
        src="/Media/HomeImages/1.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default HomeSlider;
